import { Action, combineReducers } from '@ngrx/store';

import {
  _CLEAR,
  CREATE_ROLE,
  GET_ROLES,
  UPDATE_ROLE
} from '../actions';

export function roleListReducer(state = [], action: Action) {
  switch (action.type) {
    case _CLEAR:
      return [];
    case CREATE_ROLE:
      return [ ...state, ...action.payload.roles ].sort(sortRoles);
    case GET_ROLES:
      return action.payload.roles.sort(sortRoles);
    case UPDATE_ROLE:
        return state.map(role => {
            return role.code === action.payload.role.code? action.payload.role: role;
        });
    default:
      return state;
  }
}

const sortRoles = (a, b) => {
  return +a.code - +b.code;
};

export const roleReducers = combineReducers({
  roleList: roleListReducer
});


// WEBPACK FOOTER //
// /Users/itu/Desktop/impreso_updated_sheets/impresocloud/www/client/src/ngrx/reducers/roles.ts